import React from 'react';
import { ScaledViewport } from '../ScaledViewport';

/** The live, published REKOVELLE teaser Snak. */
export const LIVE_SNAK_URL = 'https://rekovelle.snakker.io/';
interface PhoneSnakProps {
  /** Sizing classes — set a height; width follows the phone aspect ratio. */
  className: string;
  label?: string;
  /**
   * When provided, the Snak's own black "Concept" button (upper-right corner)
   * opens this presentation's concept window instead.
   */
  onConcept?: () => void;
}

/** The live REKOVELLE Snak (rekovelle.snakker.io) inside a phone frame. */
export function PhoneSnak({
  className,
  label = 'Live REKOVELLE teaser Snak',
  onConcept
}: PhoneSnakProps) {
  return <ScaledViewport baseWidth={390} baseHeight={760} bezel={10} radius={0.13} className={className} style={{
    aspectRatio: '410 / 780'
  }} deviceClassName="bg-ink shadow-[0_40px_80px_-30px_rgba(14,27,51,0.5)]" data-id="element-283" data-mp="2jkbkx8y7d4pq">
      <div className="relative h-[760px] w-[390px]" data-id="element-284" data-mp="2slj74sng2f3g">
        <iframe src={LIVE_SNAK_URL} title={label} width={390} height={760} className="block h-[760px] w-[390px] border-0 bg-white" allow="autoplay; fullscreen" data-id="element-285" data-mp="3grr39mt68kds" />
        {onConcept && <button type="button" onClick={onConcept} aria-label="Open the Snakker concept" className="absolute right-2 top-2 h-[56px] w-[128px] rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand)]" data-id="element-286" data-mp="36u39p07axix7" />}
      </div>
    </ScaledViewport>;
}